module.exports = __webpack_public_path__ + "static/img/mjgyl41.216843a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mjgyl41.png
// module id = KIUH
// module chunks = 73